// acciones
export const SAGA_GET_RESUMEN_PEDIDOS = 'pedidosReducer/SAGA_GET_RESUMEN_PEDIDOS'
export const SAGA_GET_RESUMEN_PEDIDOS_BYFILTERTEMPORAL = 'pedidosReducer/SAGA_GET_RESUMEN_PEDIDOS_BYFILTERTEMPORAL'
export const SET_RESUMEN_PEDIDOS = 'pedidosReducer/SET_RESUMEN_PEDIDOS'
export const SAGA_GET_PEDIDO_ID = 'pedidosReducer/SAGA_GET_PEDIDO_ID'
export const SAVE_PEDIDO = 'pedidosReducer/SAVE_PEDIDO'

export const SAGA_PREPARAR_PEDIDO = 'pedidosReducer/SAGA_PREPARAR_PEDIDO'
export const SAGA_PREPARAR_ITEM_PEDIDO = 'pedidosReducer/SAGA_PREPARAR_ITEM_PEDIDO'
export const SAVE_PREPARAR_ITEM_PEDIDO_RESULT = 'pedidosReducer/SAVE_PREPARAR_ITEM_PEDIDO_RESULT'
export const SAVE_MARCAR_NO_DISPONIBLE_ITEM_PEDIDO_RESULT = 'pedidosReducer/SAVE_MARCAR_NO_DISPONIBLE_ITEM_PEDIDO_RESULT'
export const SAGA_ENTREGAR_PEDIDO = 'pedidosReducer/SAGA_ENTREGAR_PEDIDO'
export const SAGA_ELIMINAR_PEDIDO = 'pedidosReducer/SAGA_ELIMINAR_PEDIDO'
export const SAGA_REVERTIR_PEDIDO = 'pedidosReducer/SAGA_REVERTIR_PEDIDO'
export const SAVE_CAMBIAR_ESTADO_RESULT = 'pedidosReducer/SAVE_CAMBIAR_ESTADO_RESULT'

export const SAGA_CARATULA_PEDIDO = 'pedidosReducer/SAGA_CARATULA_PEDIDO'
export const SAGA_REMITO_PEDIDO = 'pedidosReducer/SAGA_REMITO_PEDIDO'

export const SAGA_GET_CARRITOS_ABANDONADOS = 'pedidosReducer/SAGA_GET_CARRITOS_ABANDONADOS'
export const SET_CARRITOS_ABANDONADOS = 'pedidosReducer/SET_CARRITOS_ABANDONADOS'

export const SAGA_DELETE_CARRITO = 'pedidosReducer/SAGA_DELETE_CARRITO'
export const SET_RESULT_DELETE_CARRITO = 'pedidosReducer/SET_RESULT_DELETE_CARRITO'

export const SAGA_FETCH_PEDIDOS = 'pedidosReducer/SAGA_FETCH_PEDIDOS'
export const SAVE_PEDIDOS = 'pedidosReducer/SAVE_PEDIDOS'
export const SAGA_FETCH_ESTADOS_PEDIDO = 'pedidosReducer/SAGA_FETCH_ESTADOS_PEDIDO'
export const SAVE_ESTADOS_PEDIDO = 'pedidosReducer/SAVE_ESTADOS_PEDIDO'

export const SAGA_GET_FORMAS_ENTREGA = 'pedidosReducer/SAGA_GET_FORMAS_ENTREGA'
export const SET_FORMAS_ENTREGA = 'pedidosReducer/SET_FORMAS_ENTREGA'

export const SAGA_GET_IMAGEN_ARTICULO = 'pedidosReducer/SAGA_GET_IMAGEN_ARTICULO'
export const SAVE_IMAGEN_ARTICULO = 'pedidosReducer/SAVE_IMAGEN_ARTICULO'

export const SAGA_MARCAR_PEDIDODETALLE_LISTO = 'pedidosReducer/SAGA_MARCAR_PEDIDODETALLE_LISTO'
export const SAGA_MARCAR_PEDIDODETALLE_NODISPONIBLE = 'pedidosReducer/SAGA_MARCAR_PEDIDODETALLE_NODISPONIBLE'
export const SAGA_BUSCAR_SUGERENCIAS_REEMPLAZO = 'pedidosReducer/SAGA_BUSCAR_SUGERENCIAS_REEMPLAZO'
export const SET_LISTADO_SUGERENCIAS = 'pedidosReducer/SET_LISTADO_SUGERENCIAS'

export const SAGA_SAVE_NUEVA_CANTIDAD_PEDIDODETALLE = 'pedidosReducer/SAGA_SAVE_NUEVA_CANTIDAD_PEDIDODETALLE'
export const SAGA_QUITAR_PEDIDODETALLE_REEMPLAZO = 'pedidosReducer/SAGA_QUITAR_PEDIDODETALLE_REEMPLAZO'
export const SAGA_SAVE_NUEVO_PEDIDODETALLE_REEMPLAZO = 'pedidosReducer/SAGA_SAVE_NUEVO_PEDIDODETALLE_REEMPLAZO'

export const SAGA_SET_TOTAL_A_PAGAR = 'pedidosReducer/SAGA_SET_TOTAL_A_PAGAR'

export const SET_FILTER_PEDIDOS = 'pedidosReducer/SET_FILTER_PEDIDOS'

export const SAGA_CHANGE_TURNO_PEDIDO = 'pedidosReducer/SAGA_CHANGE_TURNO_PEDIDO'

export const SET_DIRECCIONES_ENTREGA = 'sessionReducer/SET_DIRECCIONES_ENTREGA'

export const SAGA_GEORREFERENCIACION_DOMICILIO = 'sessionReducer/SAGA_GEORREFERENCIACION_DOMICILIO'

export const SAGA_GET_ULTIMA_ACTUALIZACION = 'sessionReducer/SAGA_GET_ULTIMA_ACTUALIZACION'
export const SET_ULTIMA_ACTUALIZACION = 'sessionReducer/SET_ULTIMA_ACTUALIZACION'

export const SAGA_GET_MOTIVOS_ELIMINACION = 'pedidosReducer/SAGA_GET_MOTIVOS_ELIMINACION'
export const SET_MOTIVOS_ELIMINACION = 'pedidosReducer/SET_MOTIVOS_ELIMINACION'

export const SAGA_GET_CALENDARIO_PEDIDOS = 'pedidosReducer/SAGA_GET_CALENDARIO_PEDIDOS'
export const SAVE_CALENDARIO_PEDIDOS = 'pedidosReducer/SAVE_CALENDARIO_PEDIDOS'

// funciones
export const sagaGetMotivosEliminacion = () => ({
    type: SAGA_GET_MOTIVOS_ELIMINACION
})

export const setMotivosEliminacion = (payload) => ({
    type: SET_MOTIVOS_ELIMINACION,
    payload
})

export const saveUltimaActualizacion = (payload) => ({
    type: SET_ULTIMA_ACTUALIZACION,
    payload
})

export const sagaGetUltimaActualizacion = (payload) => ({
    type: SAGA_GET_ULTIMA_ACTUALIZACION,
    payload
})

export const sagaGeorreferenciacionDomicilio = (payload) => ({
    type: SAGA_GEORREFERENCIACION_DOMICILIO,
    payload
})

export const setdireccionesEntrega = (payload) => ({
    type: SET_DIRECCIONES_ENTREGA,
    payload
})

export const sagaChangeTurno = (payload) =>({
    type: SAGA_CHANGE_TURNO_PEDIDO,
    payload
})

export const sagaGetFormasEntrega = () =>({
    type: SAGA_GET_FORMAS_ENTREGA,
})

export const setFormasEntrega = (payload) =>({
    type: SET_FORMAS_ENTREGA,
    payload
})

export const setFilterPedidos = (payload) =>({
    type: SET_FILTER_PEDIDOS,
    payload
})

export const sagaSetTotalAPagar = (payload) =>({
    type: SAGA_SET_TOTAL_A_PAGAR,
    payload
})

export const sagaSaveNevoPedidoDetalleReemplazo = (payload) =>({
    type: SAGA_SAVE_NUEVO_PEDIDODETALLE_REEMPLAZO,
    payload
})

export const sagaQuitarPedidoDetalleReemplazo = (payload) =>({
    type: SAGA_QUITAR_PEDIDODETALLE_REEMPLAZO,
    payload
})

export const sagaSaveNuevaCantidadPedidoDetalle = (payload) =>({
    type: SAGA_SAVE_NUEVA_CANTIDAD_PEDIDODETALLE,
    payload
})

export const setListadoSugerencias = (payload) =>({
    type: SET_LISTADO_SUGERENCIAS,
    payload
})

export const sagaMarcarPedidoDetallerListo = (payload) =>({
    type: SAGA_MARCAR_PEDIDODETALLE_LISTO,
    payload
})

export const sagaMarcarPedidoDetallerNoDisponible = (payload) =>({
    type: SAGA_MARCAR_PEDIDODETALLE_NODISPONIBLE,
    payload
})

export const sagaBuscarSugerenciasReemplazo = (payload) =>({
    type: SAGA_BUSCAR_SUGERENCIAS_REEMPLAZO,
    payload
})

export const sagaGetResumenPedidos = (id) =>({
    type: SAGA_GET_RESUMEN_PEDIDOS,
    payload: {
        idCatalogo: id || -1
    }
})

export const sagaGetResumenPedidosByFilterTemporal = (payload) =>({
    type: SAGA_GET_RESUMEN_PEDIDOS_BYFILTERTEMPORAL,
    payload: payload
})

export const setResumenPedidos = (payload) =>({
    type: SET_RESUMEN_PEDIDOS,
    payload
})


export const sagaGetCarritosAbandonados = (id, page) =>({
    type: SAGA_GET_CARRITOS_ABANDONADOS,
    payload: {
        idCatalogo: id || -1,
        page: page || 1
    }
})

export const setCarritosAbandonados = (payload) =>({
    type: SET_CARRITOS_ABANDONADOS,
    payload
})


export const sagaEliminarCarrito = (idPedido, catalogo, page) =>({
    type: SAGA_DELETE_CARRITO,
    payload: {idPedido: idPedido},
    catalogo, 
    page
})

export const setResultEliminarCarrito = (payload) =>({
    type: SET_RESULT_DELETE_CARRITO,
    payload
})

export const sagaGetPedidos = (payload) => ({
    type: SAGA_FETCH_PEDIDOS,
    payload
})

export const setPedidos = (payload) => ({
    type: SAVE_PEDIDOS,
    payload
})

export const sagaGetEstadosPedido = (payload) => ({
    type: SAGA_FETCH_ESTADOS_PEDIDO,
    payload
}) 

export const setEstadosPedido = (payload) => ({
    type: SAVE_ESTADOS_PEDIDO,
    payload
})

export const sagaGetPedidoId = (id) =>({
    type: SAGA_GET_PEDIDO_ID,
    id
})
export const sagaPrepararPedido = (id) =>({
    type: SAGA_PREPARAR_PEDIDO,
    id
})
export const saveCambiarEstadoResult = (id, estado) =>({
    type: SAVE_CAMBIAR_ESTADO_RESULT,
    id,
    estado
})
export const sagaPrepararItemPedido = (id, revertir, callback)=>({
    type: SAGA_PREPARAR_ITEM_PEDIDO,
    id,
    revertir,
    callback
})

export const savePrepararItemPedidoResult = (id, revertir)=>({
    type: SAVE_PREPARAR_ITEM_PEDIDO_RESULT,
    id,
    revertir
})

export const saveMarcarNoDisponibleItemPedidoResult = (id, revertir)=>({
    type: SAVE_MARCAR_NO_DISPONIBLE_ITEM_PEDIDO_RESULT,
    id,
    revertir
})


export const sagaEntregararPedido = (id) =>({
    type: SAGA_ENTREGAR_PEDIDO,
    id
})
export const sagaEliminarPedido = (payload) =>({
    type: SAGA_ELIMINAR_PEDIDO,
    payload
})
export const sagaRevertirPedido = (id) =>({
    type: SAGA_REVERTIR_PEDIDO,
    id
})
export const sagaCaratulaPedido = (id) =>({
    type: SAGA_CARATULA_PEDIDO,
    id
})
export const sagaRemitoPedido = (id) =>({
    type: SAGA_REMITO_PEDIDO,
    id
})
export const savePedido = (pedido) =>({
    type: SAVE_PEDIDO,
    pedido,
})


export const sagaGetImagenArticulo = (id) =>({
    type: SAGA_GET_IMAGEN_ARTICULO,
    id,
})
export const saveImagenArticulo = (id,imagen) =>({
    type: SAVE_IMAGEN_ARTICULO,
    id,
    imagen
})


export const sagaGetCalendarioPedidos = (payload) =>({
    type: SAGA_GET_CALENDARIO_PEDIDOS,
    payload,
})
export const saveCalendarioPedidos = (payload) =>({
    type: SAVE_CALENDARIO_PEDIDOS,
    payload,
})
